import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ngx-patientportaldocdetails',
  templateUrl: './patientportaldocdetails.component.html',
  styleUrls: ['./patientportaldocdetails.component.scss']
})
export class PatientportaldocdetailsComponent implements OnInit {

  @Input() doctorId: string;
  @Input() docTenantId: string;
  @Input() imageLink:any;
  @Output() back = new EventEmitter<void>();

  maxStars = 5;
  reviewsList: Array<any> = [];
  doctorDetails: any = {};
  averageRating: number = 0;
  protected readonly unsubscribe$ = new Subject<void>();
  stars: string[] = [];

  constructor(protected rolesService: RolesData) { }

  ngOnInit(): void {
    this.getDoctorDetails();
  }

  getDoctorDetails() {
    this.rolesService.list("PatientFeedback/GetDoctorDetailsWithFeedBack?tenantId=" + this.docTenantId + '&doctorId=' + this.doctorId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.doctorDetails = data?.details?.doctorDetails;
      this.reviewsList = data?.details?.reviews;

      this.reviewsList.sort((a, b) => {
        return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
      });
    },(error)=>{},()=>{
      this.calculateAverageRating();
      this.getStarsArray();
    });
  }
  
  calculateAverageRating() {
    if (this.reviewsList.length > 0) {
      const total = this.reviewsList.reduce((sum, review) => sum + review.feedback_Rating, 0);
      this.averageRating = parseFloat((total / this.reviewsList.length).toFixed(1));
    }
  }

  getTimeAgo(date: Date | string): string {
    const created = new Date(date);
    const now = new Date();
    const diff = Math.floor((now.getTime() - created.getTime()) / 1000);

    const days = Math.floor(diff / (3600 * 24));
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (days === 0) return "Today";
    if (days === 1) return "Yesterday";
    if (days < 30) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (months < 12) return `${months} month${months > 1 ? 's' : ''} ago`;
    return `${years} year${years > 1 ? 's' : ''} ago`;
  }

  getStarsArray(): string[] {
    const fullStars = Math.floor(this.averageRating);
    const hasHalfStar = this.averageRating % 1 >= 0.5;

    // full stars
    for (let i = 0; i < fullStars; i++) {
      this.stars.push('full');
    }

    // half star
    if (hasHalfStar) {
      this.stars.push('half');
    }

    // empty stars
    while (this.stars.length < 1) {
      this.stars.push('empty');
    }

    return this.stars;
  }

  goBack(){
    this.back.emit()
  }

}
